class FormService {
    constructor() {}
    
    public validate(value: any, type: string | undefined, option: any): {key: string}[] {
        let errors = [];

        if (type === 'EMAIL') {
            let emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

            if (!emailRegex.test(value)) {
                errors.push({
                    key: 'invalid_email'
                });
            }
        }

        if (type === 'VALIDATE_EMAIL') {
            if (value !== option) {
                errors.push({
                    key: 'invalid_email_validation'
                });
            }
        }

        // if zipcode and country is NL only then we validate the postal code client-side (all others are only validated server-side)
        if (type === 'ZIPCODE' && option === 'NL') {
            let zipcodeRegex = new RegExp(/^[1-9][0-9]{3}[ ]?([A-RT-Za-rt-z][A-Za-z]|[sS][BCbcE-Re-rT-Zt-z])$/);

            if (!zipcodeRegex.test(value)) {
                errors.push({
                    key: 'invalid_zipcode'
                });
            }
        }

        if (!value) {
            errors.push({
                key: 'required_field'
            });
        }

        return errors;
    }
}

export default new FormService();
